/**
 *
 * @param {Contact} contact
 * @param {number} width
 * @param {number} height
 * @param {AppConfig} appConfig
 */
const getContactPhotoUrl = (contact, width, height, appConfig) => {
    if (contact.photoData) {
        return contact.photoData;
    }

    return appConfig.appUrl + contact.getPhotoPath(width, height);
};

module.exports = {
    getContactPhotoUrl,
};
